// extracted by mini-css-extract-plugin
export default {"text":"style_text__Udh5A","confirmation":"style_confirmation__itk2a","confirmation__text":"style_confirmation__text__z2MIz","confirmation__link":"style_confirmation__link__8I9uw"};